import { Dialog, DialogContent, Typography } from '@mui/material'
import { format, parseJSON } from 'date-fns'

import { FplDataGrid, FplDialogTitle, IGridColumn } from 'components/common'
import { DATE_TIME_FORMAT } from 'constants/index'
import { GET_PAGED_WEBHOOK_DELIVERIES } from 'graphql/queries'

const formatDate = ({ value }) => value && format(parseJSON(value as string), DATE_TIME_FORMAT)

const columns: IGridColumn[] = [
  { field: 'createdAt', headerName: 'Created At', minWidth: 160, valueFormatter: formatDate },
  { field: 'eventType', headerName: 'Event', minWidth: 150 },
  { field: 'eventId', headerName: 'Event Id', minWidth: 280, sortable: false },
  { field: 'status', headerName: 'Status', minWidth: 120 },
  { field: 'attemptCount', headerName: 'Attempts', minWidth: 90 },
  { field: 'lastStatusCode', headerName: 'HTTP', minWidth: 80 },
  { field: 'lastAttemptAt', headerName: 'Last Attempt', minWidth: 160, valueFormatter: formatDate },
  { field: 'nextAttemptAt', headerName: 'Next Attempt', minWidth: 160, valueFormatter: formatDate },
  { field: 'lastError', headerName: 'Last Error', minWidth: 250, flex: 1 },
]

interface IProps {
  webhookSubscriptionId: number
  openDialog: boolean
  onCloseDialog: () => void
}

const WebhookDeliveriesDialog = (props: IProps) => {
  const { webhookSubscriptionId, openDialog, onCloseDialog } = props

  return (
    <Dialog fullWidth maxWidth='xl' open={openDialog} aria-labelledby='webhook-deliveries-dialog'>
      <FplDialogTitle id='webhook-deliveries-dialog' onClose={onCloseDialog}>
        <Typography paragraph variant='h4'>
          Delivery History (last 30 days)
        </Typography>
      </FplDialogTitle>

      <DialogContent>
        <FplDataGrid
          query={GET_PAGED_WEBHOOK_DELIVERIES}
          entityName='pagedWebhookDeliveries'
          columns={columns}
          queryVariables={{ webhookSubscriptionId }}
          defaultOrder={{ field: 'createdAt', sort: 'desc' }}
          fetchPolicy='network-only'
          toolbar={{ caption: 'Deliveries', refreshButton: true }}
        />
      </DialogContent>
    </Dialog>
  )
}

export default WebhookDeliveriesDialog
